import { filter } from 'lodash'
import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import {
  API_LISTAR_TIPO_ATIVIDADES,
  API_CRIAR_TIPO_ATIVIDADES,
  API_EXCLUIR_TIPO_ATIVIDADES,
  API_ATUALIZAR_TIPO_ATIVIDADES,
} from 'store/modules/api/tipoAtividades.actions'

const lista = (state = [], { type, payload }) => {
  switch (type) {
    case API_LISTAR_TIPO_ATIVIDADES.success:
      return payload.sort((a, b) => a.nome.localeCompare(b.nome))
    case API_CRIAR_TIPO_ATIVIDADES.success:
      return [...state, payload].sort((a, b) => a.nome.localeCompare(b.nome))
    case API_ATUALIZAR_TIPO_ATIVIDADES.success:
      return state.map((e) => (e.id === payload.id ?
        payload : e))
    case API_EXCLUIR_TIPO_ATIVIDADES.success:
      return filter(state, (o) => o.id !== Number(payload))
    default: return state
  }
}

const isCarregandoLista = loadingReducer(false, API_LISTAR_TIPO_ATIVIDADES)

const isSaving = loadingReducer(false, API_CRIAR_TIPO_ATIVIDADES)
const isUpdate = loadingReducer(false, API_ATUALIZAR_TIPO_ATIVIDADES)

export default combineReducers({
  lista,
  isCarregandoLista,
  isSaving,
  isUpdate,
})
